<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="20"
        viewBox="0 0 16 20"
        fill="none"
    >
        <path
            d="M9.40444 10.2456C9.04778 9.66892 8.47667 9.53003 8.03222 9.53003C7.56444 9.53003 6.33667 9.77892 6.45111 10.9578C6.53111 11.7856 7.31111 12.0934 7.99222 12.2145C8.67333 12.3356 9.66333 12.5956 9.68778 13.5934C9.70889 14.4367 8.95 15.0123 8.03333 15.0123C7.27333 15.0123 6.71556 14.7567 6.42667 14.1856"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 8.61224V9.53002"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 15.0133V15.8344"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.94444 5.83446L12.1667 2.50113C12.1667 1.88779 11.6689 1.39001 11.0556 1.39001H7.99999H4.94444C4.33111 1.39001 3.83333 1.88779 3.83333 2.50113L6.05555 5.83446H9.94444Z"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 5.83445V4.16779"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M6.05555 5.83447C3.39888 7.25781 1.33333 10.8523 1.33333 13.89C1.33333 17.5722 4.31777 18.6122 7.99999 18.6122C11.6822 18.6122 14.6667 17.5722 14.6667 13.89C14.6667 10.8523 12.6011 7.25781 9.94444 5.83447"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
